<template>
	<div class="posts">
		<div class="section" id="blog">
			<div class="container-desktop pad-l">
				<h2 class="section-title">Blog</h2>
				<div class="contbuttonblog up">
					<a href="/posts"><button type="button" class="buttonblog">Vai al Blog</button></a>
				</div>
				<div class="latest" v-if="posts">
					<PostCard v-for="post in posts.slice(0, 4)" :key="post.id" :data="post" :tags="tags" :categories="categories" class="post" @click.native="$router.push({name: 'post', params: {slug: post.slug}})"/> <!-- @click.native="$router.push({name: 'posts'})" -->
				</div>
				<!-- <div class="contbuttonblog down">
					<a href="/posts"><button type="button" class="buttonblog">Vai al Blog</button></a>
				</div> -->
			</div>
		</div>

		<div class="section" id="said">
			<div class="container-desktop pad-l">
				<h2 class="section-title">Dicono di noi</h2>
				<h2 align="center">Scorri per scoprire cosa pensa chi si affida ad Eximus Performance!</h2>
				<Slideshow :num-slides="numSlides" :ratio="ratio" :autoplay="9998">
					<SimpleSlide v-for="i in numSlides" :key="i" :background="require(`@/assets/review-${i}.jpg`)"/>
				</Slideshow>
			</div>
		</div>

	</div>
</template>

<script>
import {notif} from '@/pop'
import {Post} from '@/plugins/api'

export default {
	name: 'posts',

	components: {
		'PostCard': () => import('./PostCard')
	},

	props: {
		autoplay: {
			type: Number,
			default: 100
		}
	},

	data() {

		return {
			posts: null,
			tags: {},
			categories: {},

			// Number of gym slides
			numSlides: 14,

			/// Image ratio
			ratio: 1.0
		}
	},

	methods: {
		/**
		 * 
		 */
		async fetchAll() {

			try
			{
				let [posts, tags, categories] = await Promise.all([Post.all({_embed: null}), Post.tags(), Post.categories()])

				this.posts = posts
				tags.forEach((tag) => this.tags[tag.id] = tag)
				categories.forEach((cat) => this.categories[cat.id] = cat)
			}
			catch (e)
			{
				/* notif.error('could not load posts') */
				console.error(e)
			}
		}
	},
	
	created() {

		// Fetch all posts
		this.fetchAll()
	}
}
</script>

<style lang="stylus" scoped>
.slideshow
	padding 1em 12em

	@media (max-width: unit(900, px))
		padding 0.5em 0em

.down 
	padding-top 3em

	@media (max-width: unit(768, px))
		padding-top 1em
.up 
	padding-bottom 2em

.contbuttonblog
	position relative
	width 210px
	margin 0 auto

	.buttonblog
		border 3px solid #dcdcdc
		color #dcdcdc
		padding 20px 40px
		width 100%
		background #101418
		border-radius 50px
		cursor pointer
		transition 0.2s ease
		font-size 1.1em
		font-weight bold
		text-transform uppercase

	.buttonblog:hover
			color #101418
			background #dcdcdc

.latest
	display grid
	grid-template-columns repeat(4, 1fr)
	grid-gap 1em

	@media (max-width: unit(1024, px))
		grid-template-columns repeat(2, 1fr)

	@media (max-width: unit(media-phone-max, px))
		display block

	.post
		cursor pointer
</style>